import React, { Component } from "react";
import { Select } from "antd";

import "./index.less";

export default class DataSelect extends Component {

  state = {
    loading: true,
  };

  options = [];

  componentDidMount() {
    this.load();
  };

  load = () => {
    this.props.onLoad().then(options => {
      this.options = options.map(item => ({
        label: item.label,
        value: item.value,
      }));
      this.setState({
        ...this.state,
        loading: false,
      });
    });
  };

  getOptions = () => {
    let options = this.options;
    const { filter, } = this.props;
    if (filter) {
      const isArray = Array.isArray(filter);
      options = options.filter(item => {
        const { value } = item;
        return isArray ? filter.includes(value) : filter(value, item);
      });
    }
    return options;
  };

  render() {
    return (
      <Select
        {...this.props}
        options={this.getOptions()}
      />
    );
  };
};
